import { createFileRoute } from '@tanstack/react-router'

import { MeterStatusType } from '@/types/meter'
import {
  Credenza,
  CredenzaBody,
  CredenzaContent,
  CredenzaDescription,
  CredenzaHeader,
  CredenzaTitle,
  CredenzaTrigger,
} from '@/components/ui/credenza'
import MeterStatusForm from '@/components/forms/meter-status-form'
import { Header } from '@/components/header'

export const Route = createFileRoute(
  '/_home/meter-connection-settings/meter-status/edit',
)({
  component: EditMeterStatusPage,
})

export default function EditMeterStatusPage({
  meterStatusData,
  setShowEditMeterStatusModal,
}: {
  meterStatusData: MeterStatusType
  setShowEditMeterStatusModal: React.Dispatch<React.SetStateAction<boolean>>
}) {
  return (
    <>
      <main>
        <CredenzaContent className="flex w-full max-w-[750px] justify-center">
          <CredenzaBody className="mx-auto w-full max-w-6xl px-4">
            <Header
              subroutes={[
                {
                  route: '/meter-connection-settings/meter-status',
                  label: 'Meter Status',
                },
              ]}
            >
              Edit Meter Status
            </Header>
            <MeterStatusForm
              setShowEditMeterStatusModal={setShowEditMeterStatusModal}
              meterStatusData={meterStatusData}
            />
          </CredenzaBody>
        </CredenzaContent>
      </main>
    </>
  )
}
